import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "walletFilled"
const WalletFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.172 6C18.92 6.085 19.5 6.719 19.5 7.489V9.364H12C10.757 9.364 9.75 10.371 9.75 11.614V16.864C9.75 18.107 10.757 19.114 12 19.114H19.5V20.989C19.5 21.817 18.828 22.489 18 22.489H3C2.172 22.489 1.5 21.817 1.5 20.989V7.489C1.5 6.719 2.08 6.085 2.828 6z" />
          <path
            fillRule="evenodd"
            d="M20.25 10.864C20.664 10.864 21 11.2 21 11.614V16.864C21 17.278 20.664 17.614 20.25 17.614H12Q11.96 17.614 11.923 17.61C11.545 17.572 11.25 17.252 11.25 16.864V11.614C11.25 11.304 11.439 11.036 11.708 10.923Q11.776 10.893 11.849 10.879 11.923 10.864 12 10.864zM14.063 12.75C13.338 12.75 12.75 13.338 12.75 14.063 12.75 14.787 13.338 15.375 14.063 15.375 14.787 15.375 15.375 14.787 15.375 14.063S14.787 12.75 14.063 12.75"
            clipRule="evenodd"
          />
          <path d="M13.362 2.291C14.072 1.913 14.955 2.161 15.362 2.856L16.326 4.5H9.218z" />
        </svg>
      }
    </span>
  )
}
export default WalletFilledIcon
